export default __webpack_public_path__ + "static/plumber-e67ac3a78910a0c4aa0b9ee6b8d2218d.png";